import { render, staticRenderFns } from "./SingleRideLegacy.vue?vue&type=template&id=244cefac&scoped=true"
import script from "./SingleRideLegacy.vue?vue&type=script&lang=js"
export * from "./SingleRideLegacy.vue?vue&type=script&lang=js"
import style0 from "./SingleRideLegacy.vue?vue&type=style&index=0&id=244cefac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244cefac",
  null
  
)

export default component.exports